import { render, staticRenderFns } from "./LogisticsViewer.vue?vue&type=template&id=5e7a78ce&scoped=true"
import script from "./LogisticsViewer.vue?vue&type=script&lang=js"
export * from "./LogisticsViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7a78ce",
  null
  
)

export default component.exports